import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [];

  openInspectionModal() {
    const element = $('#facility-new-inspection-modal');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.attr('src', element.data('targetUrl'));
    element.modal({ show: true, backdrop: 'static', keyboard: false });
  }

  openInspectionViewModal(event) {
    const element = $('#facility-view-inspection-modal');
    const clickedElement = this.getParentsUntil(event.target, "tr")[0];
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.attr('src', clickedElement.dataset.targetUrl);
    element.modal('show');
  }

  closeInspectionModal() {
    const element = $('#facility-new-inspection-modal');
    element.modal('hide');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.src = '';
  }

  getParentsUntil(el, selector) {
    let parents = [],
      _el = el.parentNode;
    while (_el && typeof _el.matches === 'function') {
      parents.unshift(_el);
      if (_el.matches(selector)) return parents;
      else _el = _el.parentNode;
    }
    return [];
  };

  closeInspectionFormModal() {
    if (confirm("Are you sure you want to exit the screen? Your changes will not be saved? If you click OK you will lose all the data.")) {
      this.closeInspectionModal();
    }
  }
}
